import { define } from "../preactement/define";
import { InlineError } from "../../InlineError";
import { parseBooleanAttr } from "../wrapperUtils";
import { jsx as _jsx } from "preact/compat/jsx-runtime";
const attributes = ['class-name', 'inversed', 'root-id'];
const Wrapper = _ref => {
  let {
    inversed,
    rootId,
    ...otherProps
  } = _ref;
  return /*#__PURE__*/_jsx(InlineError, {
    ...otherProps,
    inversed: parseBooleanAttr(inversed),
    id: rootId
  });
};

/* eslint-disable @typescript-eslint/no-namespace */

/* eslint-enable */

define('ds-inline-error', () => Wrapper, {
  attributes,
  shadow: true
});